
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Punetobhimashankarbusonrentinpune() {



    const cardData =
    {
        keyword: ' Pune to Bhimashankar Bus on Rent in Pune',
        heading: 'Amruta Travels:  Pune to Bhimashankar Bus on Rent in Pune',
        headingDescription: 'Amruta Travels offers Pune to Bhimashankar Bus on Rent in Pune, providing a reliable and comfortable transportation solution for your spiritual journey to the revered Bhimashankar Jyotirlinga. Whether you are planning a family pilgrimage, group tour, or corporate outing, our well-maintained buses ensure a smooth and devotional experience. Choose from our range of buses, including 17-seater, 32-seater, and 50-seater options, to suit your group size. With experienced drivers, punctual service, affordable pricing, and 24/7 availability, Amruta Travels makes your Pune to Bhimashankar trip simple and stress-free. Book your bus with Amruta Travels and embark on a journey of faith and comfort!',


        top: 'Top Places to Visit in Bhimashankar with Amruta Travels',



   "topPlaces": [
  {
    "title": "Bhimashankar Temple",
    "description": "Situated in the village of Bhorgiri in the Sahyadri hills, Bhimashankar Temple is one of the twelve Jyotirlingas dedicated to Lord Shiva. The temple's Nagara-style architecture and serene surroundings make it a significant pilgrimage site. It's also the origin point of the Bhima River."
  },
  {
    "title": "Bhimashankar Wildlife Sanctuary",
    "description": "Established in 1984, this sanctuary spans over 130 square kilometers and is home to the endangered Indian Giant Squirrel. The sanctuary's rich biodiversity, including various species of flora and fauna, makes it a haven for nature enthusiasts and wildlife photographers."
  },
  {
    "title": "Hanuman Lake",
    "description": "Located near the Bhimashankar Temple, Hanuman Lake is a tranquil spot surrounded by dense forests. It's an ideal location for picnics and bird watching, offering visitors a peaceful retreat amidst nature."
  },
  {
    "title": "Gupt Bhimashankar",
    "description": "Considered the original site of the Bhimashankar Jyotirlinga, Gupt Bhimashankar is accessible via a moderate trek through lush forests. The secluded location and natural beauty provide a serene environment for meditation and reflection."
  },
  {
    "title": "Nagphani Point (Nagphani Peak)",
    "description": "Also known as the 'Cobra's Hood', this peak offers panoramic views of the surrounding valleys and hills. It's a popular trekking destination, especially during the monsoon season when the landscape is lush and vibrant."
  },
  {
    "title": "Mokshakund Tirtha",
    "description": "Situated behind the Bhimashankar Temple, Mokshakund is a sacred water tank believed to have been created by the sage Kaushika. Devotees often take a dip here before proceeding to the temple, seeking spiritual purification."
  },
  {
    "title": "Sarva Tirtha",
    "description": "Located to the south of the Bhimashankar Temple, Sarva Tirtha is considered the origin point of the Bhima River. The site holds religious significance, and pilgrims often visit to perform rituals and seek blessings."
  },
  {
    "title": "Shani Mandir",
    "description": "Situated within the Bhimashankar Temple complex, the Shani Mandir is dedicated to Lord Shani. The temple houses a large antique Portuguese bell, adding historical value to the spiritual ambiance."
  },
  {
    "title": "Datta Mandir",
    "description": "This temple is dedicated to Lord Dattatreya and is located near the Bhimashankar Temple. It's a serene spot for devotees to offer prayers and experience spiritual tranquility."
  },
  {
    "title": "Ahupe Waterfalls",
    "description": "Approximately 12 kilometers from Bhimashankar, Ahupe Waterfalls is a scenic spot nestled amidst dense forests. The waterfall, along with the nearby tribal village of Ahupe, offers a glimpse into the region's natural beauty and cultural heritage."
  }
],


 "services": [
    {
      "name": "Pune to Bhimashankar Bus Rental Service",
      "description": "Amruta Travels offers reliable bus rental services for trips from Pune to Bhimashankar. Whether you're planning a religious pilgrimage, a family trip, or a corporate outing, our buses ensure a comfortable and safe journey to the Bhimashankar Jyotirlinga."
    },
    {
      "name": "Hire a Bus From Pune to Bhimashankar Darshan",
      "description": "Planning a Bhimashankar Darshan trip from Pune? Hire a bus with Amruta Travels for a smooth and comfortable ride. Our buses are equipped with modern amenities, and we ensure timely service so you can focus on your spiritual journey."
    },
    {
      "name": "Bus Rental Service Pune to Bhimashankar",
      "description": "Amruta Travels offers convenient bus rental services for travel from Pune to Bhimashankar. We provide various bus sizes to accommodate your group, ensuring a comfortable journey to one of the most revered Jyotirlingas in Maharashtra."
    },
    {
      "name": "Pune to Bhimashankar Family Trip Bus Hire",
      "description": "Make your family trip to Bhimashankar memorable with our comfortable and reliable bus hire service. Amruta Travels offers buses equipped with spacious seating and air conditioning, ensuring a pleasant and enjoyable journey for your entire family."
    },
    {
      "name": "Pune to Bhimashankar Weekend Trip Bus Rental",
      "description": "For a weekend getaway to Bhimashankar, Amruta Travels provides weekend trip bus rentals. Our buses offer a smooth and comfortable ride, making your weekend spiritual trip stress-free and enjoyable."
    },
    {
      "name": "Pune to Bhimashankar Corporate Bus Hire",
      "description": "Planning a corporate outing to Bhimashankar? Amruta Travels offers corporate bus hire services that cater to large groups, with emphasis on comfort, punctuality, and professionalism, making your trip efficient and enjoyable."
    },
    {
      "name": "Pune to Bhimashankar Group Travel Bus Rental",
      "description": "Amruta Travels offers group travel bus rental services from Pune to Bhimashankar. Whether it's a pilgrimage, school trip, or family gathering, our buses provide a comfortable and convenient mode of transportation for large groups."
    },
    {
      "name": "AC Bus Hire Pune to Bhimashankar",
      "description": "Travel in comfort with Amruta Travels’ AC bus hire for your trip from Pune to Bhimashankar. Our air-conditioned buses ensure a cool and pleasant ride, even during the warmer months, making your trip to Bhimashankar comfortable."
    },
    {
      "name": "Comfortable Bus from Pune to Bhimashankar",
      "description": "Amruta Travels offers comfortable bus rentals for your trip from Pune to Bhimashankar. Our buses are equipped with comfortable seating, air-conditioning, and all the necessary amenities to ensure a smooth journey to the Bhimashankar Jyotirlinga."
    },
    {
      "name": "32 Seater Bus Rental Pune to Bhimashankar",
      "description": "For medium-sized groups traveling from Pune to Bhimashankar, Amruta Travels offers a 32-seater bus rental. It’s an ideal choice for a family outing, corporate trip, or small group pilgrimage, ensuring comfort and safety throughout the journey."
    },
    {
      "name": "50 Seater Bus Hire from Pune to Bhimashankar",
      "description": "Amruta Travels provides a 50-seater bus rental service for large groups traveling to Bhimashankar. This spacious bus is perfect for schools, corporate groups, and large families looking for a comfortable, reliable ride."
    },
    {
      "name": "Pune Railway Station to Bhimashankar Jyotirlinga Bus",
      "description": "Amruta Travels offers a direct bus service from Pune Railway Station to Bhimashankar Jyotirlinga. Our buses are equipped with ample seating, ensuring a comfortable journey from the station to the temple for a seamless darshan experience."
    },
    {
      "name": "Pune Airport to Bhimashankar Jyotirlinga Bus On Rent",
      "description": "For travelers arriving at Pune Airport, Amruta Travels offers bus rentals for a direct journey to Bhimashankar Jyotirlinga. Our comfortable buses ensure that you can proceed directly to the temple, ready for a divine experience."
    },
    {
      "name": "Pune to Jyotirlinga Darshan Bus on Rent",
      "description": "Amruta Travels provides bus rental services for travelers planning a Jyotirlinga Darshan tour from Pune. Our buses are equipped for long-distance travel, offering comfort and convenience for your spiritual journey across Maharashtra."
    },
    {
      "name": "5 Jyotirlinga in Maharashtra Tour Package From Pune",
      "description": "Take a spiritual journey to the 5 Jyotirlingas of Maharashtra with Amruta Travels. Our tour package includes bus rentals from Pune to these sacred sites, offering a comfortable, guided, and convenient experience for your group."
    },
    {
      "name": "Jyotirlinga Darshan Package From Pune",
      "description": "Amruta Travels offers an exclusive Jyotirlinga Darshan package from Pune. This package includes comfortable bus rentals to visit the prominent Jyotirlingas across Maharashtra, with expert drivers and a planned itinerary to make your pilgrimage smooth and enjoyable."
    }
  ],
  "tableData": [
    ["Pune to Bhimashankar Bus Rental Service", "Hire a Bus From Pune to Bhimashankar Darshan"],
    ["Bus Rental Service Pune to Bhimashankar", "Pune to Bhimashankar Family Trip Bus Hire"],
    ["Pune to Bhimashankar Weekend Trip Bus Rental", "Pune to Bhimashankar Corporate Bus Hire"],
    ["Pune to Bhimashankar Group Travel Bus Rental", "AC Bus Hire Pune to Bhimashankar"],
    ["Comfortable Bus from Pune to Bhimashankar", "32 Seater Bus Rental Pune to Bhimashankar"],
    ["50 Seater Bus Hire from Pune to Bhimashankar", "Pune Railway Station to Bhimashankar Jyotirlinga Bus"],
    ["Pune Airport to Bhimashankar Jyotirlinga Bus On Rent", "Pune to Jyotirlinga Darshan Bus on Rent"],
    ["5 Jyotirlinga in Maharashtra Tour Package From Pune", "Jyotirlinga Darshan Package From Pune"]
  ],





"whychoose": [
  {
    "WhyChooseheading": "Comfortable Bus Rental from Pune to Bhimashankar",
    "WhyChoosedescription": "Amruta Travels offers dedicated bus hire services from Pune to Bhimashankar, one of the twelve revered Jyotirlingas in India. Our service is tailored for pilgrim groups, families, senior citizens, and tourists looking to experience a smooth, spiritual, and scenic journey to the Bhimashankar temple nestled in the Sahyadri hills. We ensure comfort, safety, and timely travel to enhance your darshan experience."
  },
  {
    "WhyChooseheading": "Perfect for Pilgrimage, Temple Tours, and Nature Trips",
    "WhyChoosedescription": "Whether you are planning a spiritual yatra, a monsoon nature getaway, or a cultural exploration, our Pune to Bhimashankar bus rental is ideal for all group types. The route is popular not just for its religious significance but also for its lush greenery, waterfalls, and wildlife. We make your group travel relaxing, well-coordinated, and devotional."
  },
  {
    "WhyChooseheading": "Multiple Bus Sizes for Group Travel",
    "WhyChoosedescription": "Our fleet includes AC and Non-AC buses in 17, 20, 32, 35, 40, 45, and 50-seater configurations. With push-back seats, wide windows, ample legroom, and space for luggage or prasad items, your group can travel in comfort, no matter the group size. Special arrangements can also be made for senior citizens and children in the group."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Temple Route Knowledge",
    "WhyChoosedescription": "Our drivers are familiar with the Bhimashankar temple route, including the ghat roads and narrow forest paths. They are punctual, courteous, and trained to navigate safely in varying road and weather conditions, especially during monsoons. Their experience ensures a secure and timely arrival for darshan."
  },
  {
    "WhyChooseheading": "Customizable Itineraries for Day or Overnight Trips",
    "WhyChoosedescription": "Choose from one-day express darshan trips or relaxed overnight plans with halts for meals, sightseeing, or rest. We customize the itinerary based on your preferred timings, stops, and group needs. Early morning departures or night returns can be arranged easily for added convenience."
  },
  {
    "WhyChooseheading": "Affordable Pricing with No Hidden Charges",
    "WhyChoosedescription": "Amruta Travels offers budget-friendly rates for Pune to Bhimashankar bus rental. Our transparent pricing covers fuel, tolls, driver allowance, and taxes. No hidden charges, no last-minute surprises—just clear and honest pricing that lets you focus on the spiritual aspect of your journey."
  },
  {
    "WhyChooseheading": "Clean, Safe, and Devotional-Friendly Environment",
    "WhyChoosedescription": "All buses are cleaned, sanitized, and serviced before every trip. We provide a peaceful and respectful environment perfect for religious travel. Your group can chant, listen to bhajans, or simply enjoy the serene views of the Sahyadri hills en route to the holy Bhimashankar Jyotirlinga."
  },
  {
    "WhyChooseheading": "Easy Booking and 24/7 Assistance",
    "WhyChoosedescription": "Booking your Bhimashankar bus rental is simple and quick. Use our online platform, contact our travel advisors, or visit our office. Our support team remains available 24/7 to assist with route planning, darshan time coordination, or last-minute changes, ensuring a smooth and well-managed trip."
  }
]




















    }

const faqData = [
  {
    question: 'Can I rent a bus from Pune to Bhimashankar?',
    answer: 'Yes, Amruta Travels provides comfortable and reliable bus rental services from Pune to Bhimashankar for pilgrimage, family trips, and group tours. We ensure a smooth and timely journey to this sacred destination.',
  },
  {
    question: 'What types of buses are available for the Bhimashankar trip?',
    answer: 'We offer a wide range of buses including 32, 35, 40, 45, and 50-seater options. You can choose between AC, non-AC, and luxury buses based on your budget and group size.',
  },
  {
    question: 'How long does it take to reach Bhimashankar from Pune by bus?',
    answer: 'The distance from Pune to Bhimashankar is around 110 km, and the journey typically takes 3 to 4 hours depending on traffic and road conditions.',
  },
  {
    question: 'Is the Pune to Bhimashankar trip suitable for a one-day visit?',
    answer: 'Yes, it is ideal for a one-day spiritual tour. We offer flexible schedules so you can complete darshan and return comfortably the same day.',
  },
  {
    question: 'Are your buses suitable for senior citizen groups or spiritual yatras?',
    answer: 'Absolutely. Our buses are clean, comfortable, and equipped with push-back seats and spacious interiors, making them ideal for senior citizen and religious groups.',
  },
  {
    question: 'Can I customize the pickup and drop points for my Bhimashankar trip?',
    answer: 'Yes, you can choose custom pickup and drop-off locations across Pune. We also offer multiple boarding options for larger groups or residential society pickups.',
  },
  {
    question: 'Is food allowed on the bus during the trip?',
    answer: 'Yes, you may carry packed food and water. We also plan convenient meal halts at hygienic locations en route to Bhimashankar.',
  },
  {
    question: 'What are the charges for a Pune to Bhimashankar bus rental?',
    answer: 'Pricing depends on the type of bus, trip duration, and group size. Contact us with your travel details to get a transparent and customized quote.',
  },
  {
    question: 'Why choose Amruta Travels for Bhimashankar bus hire?',
    answer: 'Amruta Travels is trusted for spiritual and temple tours. We offer punctual service, professional drivers, clean buses, and a hassle-free booking experience for all your religious travel needs.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Umesh Patil',
    role: 'Family Group Organizer',
    text: 'We booked a bus to Bhimashankar for a family yatra. The bus was clean and comfortable, and the journey was smooth. The driver was polite and knew the route well. Great service by Amruta Travels!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Rekha Joshi',
    role: 'Senior Citizen Group Leader',
    text: 'Our group had a peaceful trip to Bhimashankar with Amruta Travels. Everything was on time, and the bus was very comfortable for our senior members. Highly recommended for spiritual tours!',
    rating: 5,
  },
];





































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Bhimashankar Bus on Rent Service",
  "image": "https://bushireinpune.com/assets/images/pune-to-bhimashankar-bus-rent.jpg",
  "description": "Hire a bus from Pune to Bhimashankar for a spiritual journey to the Jyotirlinga. Amruta Travels offers 32-seater and 50-seater AC buses for family trips, corporate outings, group travel, and religious tours. Enjoy a comfortable and safe journey to Bhimashankar.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4120"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3999",  // Adjust price based on service details
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/pune-to-bhimashankar-bus-rent-service"
  }
};






    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Pune to Bhimashankar Bus Hire Service | Darshan, Family Trip & Corporate | Amruta Travels</title>
  <meta 
    name="description" 
    content="Hire buses from Pune to Bhimashankar for darshan, family trips, corporate outings, and group travel. 32, 50-seater AC buses available for a comfortable and safe journey." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/60.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetobhimashankarbusonrentinpune;